import { useEffect, useRef, useState } from "react";
import { Card, Switch, Typography, Input, Alert, message, Button, } from "antd";
import { useParams } from "react-router-dom";
import { useEventsVirtualEvents } from "features/events/use-cases/create-events-virtualEvents";
import { useGetVirtualEventsByid } from "features/events/use-cases/get-virtualEevntsById";
import { VirtualEventsView } from "../virtual-table/virtual-table";

const { Title, Text } = Typography;

export const VirtualEvents = (tabs: any) => {
    const { id } = useParams();
    const [enabled, setEnabled] = useState(false);
    const [virtualId, setVirtualId] = useState("");
    const [error, setError] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const tabsValue=tabs?.tabs
    const { mutate } = useEventsVirtualEvents();
      const { data, isLoading, refetch }: any = useGetVirtualEventsByid({
        flag: "VIRTUALEVENTID",
        EventId: id,
    } as any);
    const hasExistingId = !!data?.VirtualEventId;

    const isInitialLoadRef = useRef(true);
    const updatingRef = useRef(false);
    useEffect(() => {
        if (!data) return;

        setVirtualId(data?.VirtualEventId || "");

        if (isInitialLoadRef.current) {
            setEnabled(data?.IsVirtual);
            setIsEditing(false); // ✅ IMPORTANT: always false on load
            isInitialLoadRef.current = false;
        }
    }, [data]);
   
    
 useEffect(() => {
    if (tabsValue === "6") {

        refetch();
    } else {
        // setEnabled(false);
        setIsEditing(false);
        setError("");
        setVirtualId(data?.VirtualEventId || "");
    }
}, [tabsValue,data?.VirtualEventId])

    const handleToggle = (checked: boolean) => {
        if (updatingRef.current) return;

        updatingRef.current = true;

        setEnabled(checked);

        if (!checked) {
            setVirtualId("");
            setError("");
            setIsEditing(false);
        }

        mutate(
            {
                flag: "ACTIVEVIRTUALEVENT",
                isVirtual: checked,
                eventId: id,
            } as any,
            {
                onSuccess: (res: any) => {
                    message.success(res?.ResponseMessage || "Updated successfully");
                },
                onError: () => {
                    message.error("Something went wrong");
                    setEnabled(!checked);
                },
                onSettled: () => {
                    updatingRef.current = false;
                },
            }
        );
    };

    const handleSaveId = () => {
        if (!virtualId.trim()) {
            setError("Virtual Id is required");

            return;
        }

        mutate(
            {
                flag: "SAVEVIRTUALEVENTID",
                isVirtual: enabled,
                virtualEventId: virtualId,
                eventId: id,
            } as any,
            {
                onSuccess: (res: any) => {
                    if (res?.ResponseStatus === 0) {

                        setError(res?.ResponseMessage || "Invalid Virtual Event ID");

                        return;
                    }
                    setError("");
                    message.success(res?.ResponseMessage || "Saved successfully");
                    setIsEditing(false);
                    refetch();

                },
                onError: () => {
                    message.error("Something went wrong");
                },
            }
        );
    };

    if (isLoading) {
        return (
            <div style={{ padding: 20 }}>
                <Title level={4}>Loading Virtual Event...</Title>
            </div>
        );
    }

    return (
        <div >
            <Title level={3}>Virtual Event Setting</Title>

            <Card style={{ marginBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between",  marginBottom:15}}>
                    <div>
                        <Title level={5} style={{ marginBottom: 0 }}>
                            Virtual Event
                        </Title>
                        <Text type="secondary">
                            Participants complete from any location
                        </Text>
                    </div>

                    <Switch
                        checked={enabled}
                        onChange={handleToggle}
                        loading={updatingRef.current}
                    />
                </div>

                

                {/* {enabled && ( */}
                <>
                    <Alert
                        message="Enter the Virtual Event ID before proceeding."
                        type="warning"
                        showIcon
                        style={{
                            marginBottom: 15,
                            padding: "6px 10px",
                            fontSize: 12,
                            lineHeight: "15px"
                        }}
                    />

                    <Text strong>Virtual Event ID</Text>

                    <div
                        style={{
                            display: "flex",
                            gap: 10,
                            marginTop: 10,
                            alignItems: "flex-start",
                            marginBottom: 25 // added separation space
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            <Input
                                value={virtualId}
                                disabled={hasExistingId && !isEditing}
                                placeholder="Enter Virtual ID"
                                onChange={(e) => {
                                    setVirtualId(e.target.value);
                                    setError("");
                                }}
                                status={error ? "error" : undefined}
                            />

                            {error && (
                                <Text type="danger" style={{ marginTop: 5, display: "block" }}>
                                    {error}
                                </Text>
                            )}
                        </div>

                        {/* ✅ ONLY LOGIC YOU NEED */}
                        {hasExistingId && !isEditing ? (
                            <Button onClick={() => setIsEditing(true)}>
                                Edit
                            </Button>
                        ) : (
                            <Button type="primary" onClick={handleSaveId}>
                                Save
                            </Button>
                        )}
                    </div>
                </>
                {/* )} */}
                <div style={{ marginTop: 30 }}>
                    <VirtualEventsView tabs={tabs} />
                </div>
            </Card>
        </div>
    );
};